import AIWidget from "./components/AIWidget";

export default AIWidget;


